import { useEffect } from "react";
import {
  getBookInfo,
  getBookInfoResultStatusCode,
  getBookInfoStatus,
} from "../../api/features/bookinfo/selectors";
import { useSelector, useDispatch } from "react-redux";
import { fetchBookInfoIfNeeded } from "../../api/features/bookinfo/actions";

export default function useBookInfo() {
  const loadStatus = useSelector(getBookInfoStatus);
  const bookInfo = useSelector(getBookInfo);
  const statusCode = useSelector(getBookInfoResultStatusCode);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBookInfoIfNeeded());
  }, [dispatch]);

  return {
    loadStatus,
    bookInfo,
    statusCode,
  };
}
